import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import PageLoader from "../../components/pageLoader";
import Toast from "../../components/toast";
import ToastContainer from "../../components/toastContainer";
import InfoTab from './tabs/infoTab';
import { getCompanyById } from "../../api/companiesApi";
import DocumentsTab from "./tabs/documentsTab";
import AccountingTab from './tabs/accountingTab';

const TABS = [
  { key: "info", label: "Main Details" },
  { key: "documents", label: "Company Documents" },
  { key: "accounting", label: "Accounting" },
];

const CompanyDetailsPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("info");
  const [toast, setToast] = useState(null);

  const fetchCompany = async () => {
    try {
      setLoading(true);
      const data = await getCompanyById(id);
      setCompany(data);
    } catch (err) {
      setToast({
        type: "error",
        message: err?.response?.data?.detail || "Failed to load company",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCompany();
  }, [id]);

  if (loading) return <PageLoader />;

  if (!company) {
    return (
      <div className="p-6 text-slate-400">
        Company not found
      </div>
    );
  }

  return (
    <div className="p-6 space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <button
          onClick={() => navigate(-1)}
          className="text-sm text-slate-400 hover:text-white"
        >
          ← Back to Companies
        </button>

        {/* <button className="px-4 py-2 rounded-lg bg-pink-600 hover:bg-pink-700 text-white text-sm font-medium">
          Edit Artist
        </button> */}
      </div>

      {/* Artist Name */}
      <div>
        <h1 className="text-2xl font-semibold text-white">
          {company.name || "Company"}
        </h1>
      </div>

      {/* Tabs */}
      <div className="border-b border-white/10 flex gap-6 overflow-x-auto">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`pb-3 text-sm font-medium transition whitespace-nowrap
              ${
                activeTab === tab.key
                  ? "text-pink-500 border-b-2 border-pink-500"
                  : "text-slate-400 hover:text-white"
              }
            `}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="bg-slate-900/60 border border-white/10 rounded-xl">
        {activeTab === "info" && <InfoTab company={company} />}
        {activeTab === "documents" && <DocumentsTab company={company} />}
        {activeTab === "accounting" && <AccountingTab company={company} />}
      </div>

      <ToastContainer>
        {toast && (
          <Toast
            type={toast.type}
            message={toast.message}
            onClose={() => setToast(null)}
          />
        )}
      </ToastContainer>
    </div>
  );
};

export default CompanyDetailsPage;
